<div class="py-4 container-fluid teach-compensation-report-page">
  <h4 class="mb-4 teach-compensation-report-title">
    การจัดการคำขอสอนชดเชย - รายงานคำขอสอนชดเชย
  </h4>

  <div class="teach-compensation-report-card">
    <div class="teach-compensation-report-card-body">
      <div class="teach-compensation-report-toolbar" [formGroup]="form">
        <div class="teach-compensation-report-filter">
          <app-select
            label="เทอมการศึกษา"
            formControlName="academicTerm"
            [options]="academicTermOptions"
            [searchable]="false"
            [clearable]="false"
            inputClass="teach-compensation-report-select"
            classes="mb-0"
          ></app-select>
        </div>

        <div class="teach-compensation-report-filter">
          <app-select
            label="ปีการศึกษา"
            formControlName="year"
            [options]="yearOptions"
            [searchable]="false"
            [clearable]="false"
            inputClass="teach-compensation-report-select"
            classes="mb-0"
          ></app-select>
        </div>

        <div class="teach-compensation-report-search">
          <app-filter-search-input
            label="ชื่อ - นามสกุล, อีเมล"
            formControlName="keyword"
            inputClass="teach-compensation-report-search-input"
            classes="mb-0"
            ariaLabel="ค้นหาอาจารย์"
            (searchSubmit)="onSearch()"
          ></app-filter-search-input>
        </div>

        <div class="teach-compensation-report-filter">
          <app-select
            label="สาขาวิชา"
            formControlName="departmentId"
            [options]="departmentOptions"
            bindLabel="name"
            bindValue="id"
            [searchable]="true"
            [clearable]="true"
            inputClass="teach-compensation-report-select"
            classes="mb-0"
          ></app-select>
        </div>
      </div>

      <ng-template #rowIndexTemplate let-row="row">
        {{ row.sequence ?? '-' }}
      </ng-template>

      <ng-template #actionTemplate let-row="row">
        <div class="teach-compensation-report-actions">
          <button
            type="button"
            class="btn teach-compensation-report-action-button datatable-view-action-button"
            aria-label="ดูรายการคำขอสอนชดเชย"
            (click)="onViewRequests(row)"
          >
            <img
              src="assets/media/icons/svg/eye.svg"
              class="teach-compensation-report-action-icon datatable-view-action-icon"
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
      </ng-template>

      <app-datatable
        [datasource]="datasource()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [limit]="50"
        [showOrder]="false"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="datasource().page"
        [limit]="datasource().limit"
        [total]="datasource().total"
        [totalPage]="datasource().total_page"
        [offset]="datasource().offset"
        [dataLength]="datasource().data.length"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="teach compensation report pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>
</div>
